module.exports = __webpack_public_path__ + "static/media/amber-beer@3x.85bcc1fc.png";